<h2 style="text-align:center">Second Meeting Form</h2>
<router-outlet *ngIf="!loading" name="meeting_2"></router-outlet>

<survey-project-meeting *ngIf="auth.isProject() || auth.isAdmin() || auth.isProjectBoard() || auth.isCallManager() " [step]="2"></survey-project-meeting>